<template>
    <div class="tab-text">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Google Analytics ID</span>
          <div style="font-size:0.75rem; color:#aaa;">
            You can get this from the Google Analytics account. For enhanced
            tracking, please turn on Ecommerce Tracking in Google Analytics.
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            v-model="basicForm.gaid"
            placeholder="Eg., UA-12345678-2"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Facebook Pixel ID</span>
          <div style="font-size:0.75rem; color:#aaa;">
            You can get this from the Facebook Pixel code
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            v-model="basicForm.fbpid"
            placeholder="Eg., 1696938513929033"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Adwords ID</span>
          <div style="font-size:0.75rem; color:#aaa;">
            You can get this from the Google Adwords tracking code
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            v-model="basicForm.awcid"
            placeholder="Eg., AW-123456789"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Adwords Label</span>
          <div style="font-size:0.75rem; color:#aaa;">
            You can get this from the Google Adwords tracking code
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            v-model="basicForm.awclabel"
            placeholder="Eg., OFWIFPDxlnxQrqfXiwD"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Custom Code</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Added to the HTML at the bottom of the page
          </div>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="basicForm.code_footer" />
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="vx-row pt-2 mt-0">
        <div class="vx-col w-full ml-auto">
          <vs-button class="mr-3 mb-2" @click="submitBasic">Save </vs-button>

          <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
        </div>
      </div>
    </div>

</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import Service from "@/services";

import { currencyList, protypeList } from "@/utils/Constants";
import { timezones } from "@/utils/Timezones";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import { basicForm, currencyForm } from "@/utils/eventForm";

export default {
  components: {},
  props: {
    event: null,
    role: null,
    basicForm: basicForm,
    currencyForm: currencyForm,
    folder: null
  },
  data() {
    return {};
  },
  methods: {
    replaceAll(str, find, replace) {
      if (str == "" || str == null) {
        return str;
      }
      return str.replace(new RegExp(find, "g"), replace);
    },
    submitBasic() {
      this.basicForm.e = this.folder;

      /*CONVERT DATE FORMAT */
      this.basicForm.datetime = moment(this.basicForm.daterange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.basicForm.datetime_end = moment(this.basicForm.daterange[1]).format(
        "YYYY-MM-DD HH:mm"
      );

      if (this.basicForm.datetime == "Invalid date") {
        this.basicForm.datetime = moment(
          this.basicForm.daterange[0],
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }

      if (this.basicForm.datetime_end == "Invalid date") {
        this.basicForm.datetime_end = moment(
          this.basicForm.daterange[1],
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }

      if (this.basicForm.featured_status == 0) {
        this.basicForm.featured_status = null;
      }

      if (!this.currencyForm.hasReference) {
        this.basicForm.altcurrencycode = null;
        this.basicForm.altcurrencyrate = null;
      }

      this.$vs.loading();

      let shortDesc = this.replaceAll(this.basicForm.shortdesc, "<p", "<div");
      shortDesc = this.replaceAll(shortDesc, "<\/p>", "<\/div>");

      let longDesc = this.replaceAll(this.basicForm.longdesc, "<p", "<div");
      longDesc = this.replaceAll(longDesc, "<\/p>", "<\/div>");

      let inviteText = this.replaceAll(this.basicForm.invitetext, "<p", "<div");
      inviteText = this.replaceAll(inviteText, "<\/p>", "<\/div>");

      let invInstText = this.replaceAll(
        this.basicForm.taxinv_instruction,
        "<p",
        "<div"
      );
      invInstText = this.replaceAll(invInstText, "<\/p>", "<\/div>");

      let instruction = this.replaceAll(
        this.basicForm.instruction,
        "<p",
        "<div"
      );
      instruction = this.replaceAll(instruction, "<\/p>", "<\/div>");

      let refundpolicy = this.replaceAll(
        this.basicForm.refundpolicy,
        "<p",
        "<div"
      );
      refundpolicy = this.replaceAll(refundpolicy, "<\/p>", "<\/div>");

      let lobby_intro = this.replaceAll(
        this.basicForm.lobby_intro,
        "<p",
        "<div"
      );
      lobby_intro = this.replaceAll(lobby_intro, "<\/p>", "<\/div>");

      let intro = this.replaceAll(this.basicForm.intro, "<p", "<div");
      intro = this.replaceAll(intro, "<\/p>", "<\/div>");

      Service.Event.update({
        ...this.basicForm,
        shortdesc: shortDesc,
        longdesc: longDesc,
        instruction: instruction,
        lobby_intro: lobby_intro,
        refundpolicy: refundpolicy,
        // lobby_intro: lobby_intro,
        // instruction: instruction,
        // inviteText: inviteText,
        invInstText: invInstText
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push(`/dash`)
    }
  }
};
</script>
